export default __webpack_public_path__ + "static/media/medal-gold.19ea36ff.svg";